import { render } from "./InputFileManagerInsideTemplate.vue?vue&type=template&id=efa2237c&scoped=true"
import script from "./InputFileManagerInsideTemplate.vue?vue&type=script&lang=js"
export * from "./InputFileManagerInsideTemplate.vue?vue&type=script&lang=js"

import "./InputFileManagerInsideTemplate.vue?vue&type=style&index=0&id=efa2237c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa2237c"]])

export default __exports__